// tslint:disable:jsx-no-lambda
// tslint:disable:object-literal-sort-keys
import { Link } from '@reach/router';
import React, { useContext } from 'react';
import { ButtonFilled } from '../../../components/ui';
import { Notebook } from '../../../context/notebook';
import { NotebookContext } from '../../../context/NotebookContext';
import client from '../../../lib/client';
import { trackerDeleteMutation } from '../../../queries/trackers';
import {
  TrackerDeleteMutation,
  TrackerDeleteMutationVariables
} from '../../../queries/__generated__/TrackerDeleteMutation';
import { back } from '../../../lib/helpers/navigate';

const deleteTracker = async (trackerId: string, notebook: Notebook, reloadNotebook: any) => {
  await client
    .mutate<TrackerDeleteMutation, TrackerDeleteMutationVariables>({
      mutation: trackerDeleteMutation,
      variables: { id: trackerId }
    })
    .then(() => client.resetStore())
    .then(() => back());
};

interface TrackerDeleteProps {
  trackerId: string;
}

const TrackerDelete: React.FC<TrackerDeleteProps> = ({ trackerId }) => {
  const { notebook, reloadNotebook } = useContext(NotebookContext);

  return (
    <div className="min-vh-100 flex flex-column items-center justify-center pa3">
      <div className="tc mw6">
        <p className="serif lh-copy measure-narrow mt0 mb4">
          You’ll lose all your data for this tracker. Are you sure you want to delete it?
        </p>

        <ButtonFilled
          className="mb3"
          onClick={() => deleteTracker(trackerId, notebook, reloadNotebook)}
          data-testid="confirm-delete-button"
        >
          Yes, Delete
        </ButtonFilled>
        <button
          className="db f6 blue hover-navy center mt2"
          onClick={() => back()}
          data-testid="cancel-delete-button"
        >
          No, Don’t Delete
        </button>
      </div>
    </div>
  );
};

export default TrackerDelete;
